// Sliders
import './sliders';

// Events page script
import './_events';